:host {
  font-family: var(--pl-font-family);
  font-size: var(--pl-font-size);
  --padding-bottom: 5.75rem;
}

@media print {
  :host {
    display: none;
  }
}

*, *::before, *::after {
  box-sizing: border-box;
}

.website-footer-wrapper {
  background: var(--pl-color-penn-blue);
  padding-bottom: var(--padding-bottom);
}

.viewport-margins {
  max-width: var(--pl-viewport-margins-max-width);
  margin: 0 auto;
  padding: 0 var(--pl-viewport-margins-gutter, 1em);
}

.website-footer {
  background-size: cover;
  color: var(--pl-color-fg-subtle-on-emphasis);
}

.website-footer a {
  color: var(--pl-color-fg-subtle-on-emphasis);
}

.website-footer__content {
  padding: 4em 0;
}

.website-footer__links-container {
  gap: 4em 2em;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12em, 1fr));
}

.website-footer__heading {
  font-size: 0.8em;
  text-transform: uppercase;
  letter-spacing: 0.075em;
  margin-bottom: 1em;
  opacity: 0.75;
}

.website-footer__links {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.75em;
}

.website-footer__links a {
  text-decoration: none;
}

.website-footer__links a:hover {
  text-decoration: underline;
  text-underline-offset: var(--pl-link-text-underline-offset);
}

.website-footer__footer {
  padding: 1em 0;
  background: rgba(1, 31, 91, 0.65);
}

.website-footer__links--footer {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  flex-direction: row;
  margin-left: -0.5em;

  @media (max-width: 1080px) {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(16em, 1fr));
  }
}

.website-footer__links--footer a {
  display: inline-block;
  padding: 0.5em 0.75em;
  font-size: 0.875em;
  opacity: 0.875;
  font-weight: 500;
}

.website-footer__links--footer a:hover {
  text-decoration: underline;
  text-underline-offset: var(--pl-link-text-underline-offset);
}